import PopupBase from "scripts/dom_utils/popups/popup_base";
import { qs, qsAll } from "scripts/data_utils/domHelpers";

class PopupPrompt extends PopupBase {
  constructor(el) {
    super(el);
    this.showFieldError = this.showFieldError.bind(this);
    this.showAllErrors = this.showAllErrors.bind(this);
    this.hideFieldError = this.hideFieldError.bind(this);
    this.hideAllFieldsError = this.hideAllFieldsError.bind(this);
    this.hideErrorOnClickOnField = this.hideErrorOnClickOnField.bind(this);
    this.disableSubmitButton = this.disableSubmitButton.bind(this);
    this.enableSubmitButton = this.enableSubmitButton.bind(this);
  }

  disableSubmitButton() {
    this.button.disabled = true;
    this.button.appendChild(this.loader);
  }

  enableSubmitButton() {
    this.button.disabled = false;
    this.button.removeChild(this.loader);
  }

  showAllErrors(errors) {
    errors.map(error => {
      this.showFieldError(this.form, error.field, error.messages.join(", "));
    });
  }

  showFieldError(target, fieldName, message) {
    const errorContainer = qs(`.js-error-container.form-error-${fieldName}`, target);

    if (!errorContainer) {
      return;
    }

    errorContainer.style.display = "block";
    errorContainer.innerHTML = message;
  }

  hideFieldError(target) {
    const errorContainers = [qs(".js-error-container", target.parentNode), qs(".js-__all__")];
    errorContainers.map(el => {
      if (el) {
        el.style.display = "hide";
        el.innerHTML = "";
      }
    });
  }

  hideAllFieldsError() {
    const errorContainers = qsAll(".js-error-container");
    errorContainers.map(el => {
      if (el) {
        el.style.display = "none";
      }
    });
  }

  hideErrorOnClickOnField() {
    Object.keys(this.fields).map(field => {
      const el = this.fields[field];
      el.addEventListener("click", () => this.hideFieldError(el));
    });
  }

}

export default PopupPrompt;